import { MappedClass, MappedProperty, MappedPropertyCurrency } from '@h5s/util-object';
import Big from 'big.js';
import { Product } from './product';

export interface CreateProductFields {
  available: boolean | null;
  basePrice: Big;
  category2Id: number | null;
  categoryId: number | null;
  channelManagerCode: string | null;
  costCenterId: number | null;
  defaultPriceListId: number | null;
  departmentId: number | null;
  description: string;
  descriptionDe: string | null;
  descriptionEn: string | null;
  descriptionEs: string | null;
  descriptionFr: string | null;
  exportCode: string | null;
  notes: string | null;
  notesDe: string | null;
  notesEn: string | null;
  notesEs: string | null;
  notesFr: string | null;
  priceLists: number[];
  vat: Big | null;
  vatRateId: number | null;
  webAvailable: boolean | null;
}

@MappedClass()
export class CreateProduct implements CreateProductFields {
  @MappedProperty()
  available: boolean | null = null;

  /** (MANDATORY) */
  @MappedPropertyCurrency()
  basePrice: Big;

  @MappedProperty()
  category2Id: number | null = null;

  @MappedProperty()
  categoryId: number | null = null;

  @MappedProperty()
  channelManagerCode: string | null = null;

  @MappedProperty()
  costCenterId: number | null = null;

  @MappedProperty()
  defaultPriceListId: number | null = null;

  @MappedProperty()
  departmentId: number | null = null;

  /** (MANDATORY) */
  @MappedProperty()
  description: string;

  @MappedProperty()
  descriptionDe: string | null = null;

  @MappedProperty()
  descriptionEn: string | null = null;

  @MappedProperty()
  descriptionEs: string | null = null;

  @MappedProperty()
  descriptionFr: string | null = null;

  @MappedProperty()
  exportCode: string | null = null;

  @MappedProperty()
  notes: string | null = null;

  @MappedProperty()
  notesDe: string | null = null;

  @MappedProperty()
  notesEn: string | null = null;

  @MappedProperty()
  notesEs: string | null = null;

  @MappedProperty()
  notesFr: string | null = null;

  @MappedProperty()
  priceLists: number[] = [];

  @MappedPropertyCurrency()
  vat: Big | null = null;

  @MappedProperty()
  vatRateId: number | null = null;

  @MappedProperty()
  webAvailable: boolean | null = null;

  constructor(fields?: CreateProductFields) {
    Object.assign(this, fields);
  }

  public static fromProduct(product: Product): CreateProduct {
    return new CreateProduct({
      available: product.available,
      basePrice: product.basePrice,
      category2Id: product.category2Id,
      categoryId: product.categoryId,
      channelManagerCode: product.channelManagerCode,
      costCenterId: product.costCenterId,
      defaultPriceListId: product.defaultPriceListId,
      departmentId: product.departmentId,
      description: product.description,
      descriptionDe: product.descriptionDe,
      descriptionEn: product.descriptionEn,
      descriptionEs: product.descriptionEs,
      descriptionFr: product.descriptionFr,
      exportCode: product.exportCode,
      notes: product.notes,
      notesDe: product.notesDe,
      notesEn: product.notesEn,
      notesEs: product.notesEs,
      notesFr: product.notesFr,
      priceLists: product.priceLists.map((priceList) => priceList.id),
      vat: product.vat,
      vatRateId: product.vatRateId,
      webAvailable: product.webAvailable,
    });
  }
}
